(function() { window.GUID_00c7f153_7f3e_493a_a705_77b8648972a0 = { getGuid: function() { return "00c7f153-7f3e-493a-a705-77b8648972a0"; } }; })();
var PersonnalSchedule;
(function (PersonnalSchedule) {
    $(function () {
        let gridViewPersonnalScheduleUI = $('#GridViewPersonnalSchedule');
        let gridViewPersonnalSchedule = gridViewPersonnalScheduleUI.data('context');
        CS.body.on('Refreshed', '#GridViewPersonnalSchedule', function (e, gridView) {
            gridViewPersonnalSchedule = gridView;
        });
        var btnPrintSchedule = $('#BtnPrintSchedule');
        btnPrintSchedule.off('click');
        document.SelectedEntityBaseId.SelectionChange = function () {
            if (this.val() != "0" && this.val() != "") {
                btnPrintSchedule.removeClass('IsDisabled');
            }
            else {
                btnPrintSchedule.addClass('IsDisabled');
            }
        };
        btnPrintSchedule.on('click', 'a', function (e) {
            var reportParam = "?ReportName=LeagueEntitySchedule" +
                "&ShowReportViewer=false" +
                "&EntityBaseId=" + document.SelectedEntityBaseId.val() +
                "&SelectedStatGroupId=null";
            this.target = "_blank";
            this.href = CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam;
            document.SelectedEntityBaseId.val();
        });
    });
})(PersonnalSchedule || (PersonnalSchedule = {}));

//# sourceMappingURL=PersonnalSchedule.js.map
